import * as React from 'react'
import { Route, Switch } from 'react-router-dom'

import Root from './components/layout/Root'
// import Header from './components/layout/Header'
import FancyHeader from './components/layout/FancyHeader'
import IndexPage from './pages/index'
import ProjectsPage from './pages/projects'
import ExperimentsPage from './pages/experiments'
import EventsPage from './pages/events'
import BlogsPage from './pages/blogs'
import ResourcePage from './pages/resources'
import AuthorPage from './pages/authors'
import TextPage from './pages/texts'
import ContactPage from './pages/contact'
import { withAuthentication } from './components/firebase/withAuthentication'
import { firebase } from './components/firebase'

// If your app is big + you have routes with a lot of components, you should consider
// code-splitting your routes! If you bundle stuff up with Webpack, I recommend `react-loadable`.
//
// $ yarn add react-loadable
// $ yarn add --dev @types/react-loadable
//
// The given `pages/` directory provides an example of a directory structure that's easily
// code-splittable.

class Routes extends React.Component {
  constructor(props: any) {
    super(props)

    this.state = {
      authUser: null
    }
  }
  public componentDidMount() {
    firebase.auth.onAuthStateChanged(authUser => {
      authUser ? this.setState(() => ({ authUser })) : this.setState(() => ({ authUser: null }))
    })
  }
  public render() {
    return (
      <Root>
        {/* <Header title="C-LAB" logo={require('./images/logo.svg')} /> */}
        <FancyHeader title="C-LAB" logo={require('./images/logo.svg')} />
        <Switch>
          <Route exact path="/" component={IndexPage} />
          <Route path="/projects" component={ProjectsPage} />
          <Route path="/experiments" component={ExperimentsPage} />
          <Route path="/events" component={EventsPage} />
          <Route path="/blogs" component={BlogsPage} />
          <Route path="/resources" component={ResourcePage} />
          <Route path="/about" component={AuthorPage} />
          <Route path="/authors" component={AuthorPage} />
          <Route path="/texts" component={TextPage} />
          <Route path="/contact" component={ContactPage} />
          <Route component={() => <div>Not Found</div>} />
        </Switch>
      </Root>
    )
  }
}

export default withAuthentication(Routes)
